import Box from "@mui/material/Box";
import React from "react";

const LoginLayout = ({ children }) => <Box
	sx={{
		p: 1,
		minHeight: "100vh",
		display: "flex",
		justifyContent: "center",
		flexDirection: "column"
	}}
>
	{children}
</Box>


export default LoginLayout
